import { GetLinks } from "../../../config";

export default [
  {
    key: "/dashboard",
    icon: <i className="ki-outline ki-home-2 fs-1 " />,
    label: GetLinks("/dashboard", "Dashboard"),
  },
];
